import { connect } from "react-redux";
import {
  getCountryCode,
  getDefaultLanguage,
  getKeyStoreDataversion,
  getStoreCode
} from "../../../state/modules/regionalStore";
import { isLoggedIn } from "../../../state/modules/user";
import ContactPreferences from "./ContactPreferences";
import { buildBasicPayload } from "../../../state/modules/analytics/actions";

const mapStateToProps = state => ({
  countryCode: getCountryCode(state),
  isLoggedIn: isLoggedIn(state),
  keyStoreDataversion: getKeyStoreDataversion(state),
  lang: getDefaultLanguage(state),
  storeCode: getStoreCode(state)
});

const mapDispatchToProps = {
  buildBasicPayload
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactPreferences);



// WEBPACK FOOTER //
// ./template/components/GDPR/ContactPreferences/index.js